export default __webpack_public_path__ + "static/media/notification-4.3a9f97d7.mp3";